import { app } from '../../utils/store'
import Swiper from "swiper/bundle"

export default class CarouselAwards {
    constructor({ element }) {
        this.element = element

        this.create(this.element)
    }

    create = (entry) => {
        if(entry) {
            this.slider = {
                section: entry,
                swiper: entry.querySelector('.swiper'),
            }
            
            if (this.slider?.swiper) {
                this.slider.controls = this.slider.section.querySelector(".controls")

                this.slider.swiper = new Swiper(this.slider.swiper, {
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: this.slider.controls.querySelector("[data-next]"),
                        prevEl: this.slider.controls.querySelector("[data-prev]"),
                        clickable: true,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        1200: { slidesPerView: 2 }
                    },
                    centerInsufficientSlides: false,
                    autoHeight: false,
                })
            }
        } else {
            console.log('Errore: elemento `entry` mancante')
        }
    }
}